<template>
  <div>
    <el-col style="flex:1;border-right: 1px solid #D7D7D7;padding-right: 30px;" :xs="24" :lg="19" :md="18" :sm="24">
      <div class="product-container">
        <div class="product-wrapper">
          <div class="product-wrapper-left">
            <div class="product-item" v-for="(item,index) in r.data.data" :key="index">
              <div style="position: relative;">
                <img :src="item.img || item.picture" style="width:120px;height:120px;object-fit: contain;" />
                <span class="goodsNum" v-if="item.number>1">{{item.number}}</span>
              </div>
              <div class="product-detail">
                    <div class="product-name">
                      <p>{{ item.coding }}</p>
                    </div>
                    <p>颜色等：{{ item.colorOther }}</p>
                    <p>尺码等：{{ item.sizeOther }}</p>
                    <p class="product-price">
                      <label>{{ item.price}}</label>
                    </p>
              </div>
              <!--<div style="padding-left:30px;width:20%;">
                <el-button class="block btn-14" type="info" @click="updateMail(item)">处理邮件</el-button>
              </div>-->
            </div>
          </div>
          <div class="product-wrapper-right">
            
          </div>
        </div>
      </div>
    </el-col>
    <el-col style="padding-left:50px;" :span="5">
      <!--<div>
        <el-select v-loading="r.updating" style="width:100%;margin-bottom: 20px;" v-model="r.status" :disabled="r.updating"
          class="input-width middle-text" :class="{'black':r.status==2}" @change="updateMail(index)">
          <el-option label="已处理" value="1"></el-option>
          <el-option label="待处理" value="2"></el-option>
        </el-select>
      </div>-->
      <div>
        <template v-if="r.merchant_order_number">
          <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">订单号</p>
          <template v-if="r.merchant_order_link">
            <p style="margin-bottom: 10px;">
              <i class="el-icon-link" style="position:relative;top:1px;"></i>
              <a class="content_link" target="_blank" :href="r.merchant_order_link">{{ r.merchant_order_number }}</a>  
            </p>
          </template>
          <template v-else>
            <p style="margin-bottom: 10px;">{{ r.merchant_order_number }}</p>
          </template>
        </template>
      </div>
      <div>
        
      </div>
    </el-col>
  </div>
</template>

<script>
import Order from '../list/Order'
import { API_HOST, FILE_HOST,SPEC_MAPPER } from '../../../services/constant.js'
import api from '../../../services/api.js'
let _ = require('lodash')

export default {
  name: 'OrderList',
  props:['r','index','taskDisplay'],
  components: {
    Order:Order
  },
  data() {
    return {
      showForward:false
    }
  },
  async mounted() {
    
  },
  methods: {
    displayFirstLine(str){
      return str.split("\<br>")[0]
    },
    async updateMail(index){
      this.$emit('updateMail',index)
    },   
  }
}
</script>

<style lang="scss">
  .content_link{
    color:#303133;
  }
.product-container{
      padding:15px 0;
      border-bottom: 1px solid #D7D7D7;
      &:first-child{
        padding-top:0;
      }
      &:last-child{
        padding-bottom:0;
        border-bottom:none;
      }
      &.order{
        display: flex;
        justify-content: space-between;
      }
    }
.product-wrapper{
      display:flex;
      justify-content:space-between;  
      .product-wrapper-left.lika{
        margin-left:237px;
        &.taskDisplay{
          margin-left:200px;
        }
      }
      .product-wrapper-right{
        text-align:right;
      }
      &:last-child{
        margin-bottom:0;
      }
      &.order{
        flex:1;
        border-right: 1px solid #D7D7D7;
        padding-right: 25px;
        line-height:1;
      }
      .product-wrapper-right.order p{
        color:#888888;
      }
    }
    .product-item{
      display:flex;
      height:120px;
      margin-bottom:30px;
      &:first-child{
        padding-top:0;
      }
      &:last-child{
        border-bottom:0;
        padding-bottom: 0;
        margin-bottom:0;
      }
      .product-detail{
          display:flex;
          flex-direction:column;
          justify-content:space-between;
          flex:1;
          position:relative;
          top:-3px;
          margin-left:20px;
          .product-name{
            font-size: 14px;
            color: #333333;
          }
          .product-price{
            line-height: 32px;
            color: black;
            label{
              font-size: 18px;
            }
          }
          .product-price del{
            font-size: 16px;
          }
      }
    }
  .product-price label.danger{
    font-size: 18px;
    color:#FF4650;
  }
  .goodsNum{
            position: absolute;
            top: -10px;
            right:0;
            display: inline-block;
            height: 20px;
            width: 20px;
            border: 1px solid #D7D7D7;
            border-radius: 50%;
            text-align: center;
            font-size: 10px;
            line-height: 18px;
            color: white;
            background: black;
          }
</style>



// WEBPACK FOOTER //
// src/pages/orders/daigou/DaigouBody.vue